import React from "react";
import DataCtx from "./api/DataCtx";
import { useTranslation } from "react-i18next";
import { formatValue } from "./utils";
import { IParameter, parameterMap } from "./parametermapping";
import Compass from "./Compass";

interface Props {
    parameterLabel: string;
    onClick: (filter: number | undefined) => void;
    compass?: boolean;
}

const DisplayCell: React.FC<Props> = (props) => {

    const { t } = useTranslation();

    const parameter: IParameter = parameterMap.filter(parameter => parameter.label == props.parameterLabel)[0];

    const data = React.useContext(DataCtx);

    const record = data.params.filter(p => p.issue === parameter.issue)[0];

    const floatValue = parseFloat(record.value);
    const formattedValue = formatValue(record, parameter.decimalDigits, parameter.calc)

    return (
        <div 
            className="datacell" 
            style={{cursor: 'pointer'}}
            title={`${t('valueReceived')} ${new Date(record.timestamp).toString()}`} 
            onClick={() => props.onClick(parameter.id)}
        >
            <div className="datacelllabel"
            
            style={{
                //fontSize: t(props.parameterLabel).length > 30 ? 18 : 18,
            }}
            >{t(props.parameterLabel)}</div>
            { (props.compass && !isNaN(floatValue)) ? <div className="datacellcompass"><Compass formattedValue={formattedValue} dir={floatValue} /></div> : <div className="datacellvalue">{formattedValue}</div>}
        </div>
    )
};

export default DisplayCell;

